import PositionListItem from 'components/PositionListItem'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { MEDIA_WIDTHS } from 'theme'
import { PositionDetails } from 'types/position'
import FilterButton from './FilterButton'

const DesktopHeader = styled.div`
  display: none;
  font-size: 14px;
  font-weight: 500;
  padding: 8px;

  @media screen and (min-width: ${MEDIA_WIDTHS.upToSmall}px) {
    align-items: center;
    display: flex;

    display: grid;
    grid-template-columns: 1fr 1fr;
    & > div:last-child {
      text-align: right;
      margin-right: 12px;
    }
  }
`

const MobileHeader = styled.div`
  font-weight: medium;
  font-size: 16px;
  font-weight: 500;
  padding: 8px;
  @media screen and (min-width: ${MEDIA_WIDTHS.upToSmall}px) {
    display: none;
  }
`

export type PositionListProps = React.PropsWithChildren<{
  positions: PositionDetails[]
}>

export default function PositionList({ positions }: PositionListProps) {
  const { t } = useTranslation()
  const [inRange, setInRange] = React.useState(true)
  const [outOfRange, setOutOfRange] = React.useState(false)
  const [inactive, setInactive] = React.useState(false)

  return (
    <>
      <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
        <FilterButton checked={inRange} onClick={() => setInRange(!inRange)}>
          In range
        </FilterButton>
        <FilterButton checked={outOfRange} onClick={() => setOutOfRange(!outOfRange)}>
          Out of range
        </FilterButton>
        <FilterButton checked={inactive} onClick={() => setInactive(!inactive)}>
          Inactive
        </FilterButton>
      </div>

      <DesktopHeader>
        <div>
          {t('Your positions')}
          {positions && ' (' + positions.length + ')'}
        </div>
        <div>{t('Price range')}</div>
      </DesktopHeader>
      <MobileHeader>Your positions</MobileHeader>
      {positions.map((p) => {
        return (
          <PositionListItem
            key={p.tokenId.toString()}
            positionDetails={p}
            inRange={inRange}
            outOfRange={outOfRange}
            inactive={inactive}
          />
        )
      })}
      {/*    <AutoColumn justify={'center'} gap="md">
        <Text textAlign="center" fontSize={14} style={{ padding: '.5rem 0 .5rem 0', marginTop: '14px' }}>
          {'Want to migrate your V2 Liquidity?'}{' '}
          <StyledInternalLink id="migrate-pool-link" to={'/migrate/v2'}>
            {'Migrate V2 liquidity.'}
          </StyledInternalLink>
        </Text>
      </AutoColumn> */}
    </>
  )
}
